import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import Button from "content/button/button";
import { useResources } from "contexts/resource-context";

const AdminHeader: React.SFC<{ title: string } & RouteComponentProps> = ({
    history,
    title,
}) => {
    const resource = useResources();

    return (
        <div className={"row mb-3"}>
            <div className={"col-8"}>
                <h1>{title}</h1>
            </div>

            <div className={"col-4 text-right pt-2"}>
                <Button
                    className={"mb-2"}
                    text={resource.Admin_Header_Back}
                    iconClass={"fas fa-arrow-left"}
                    onClick={history.goBack}
                />

                <Button
                    className={"ml-2 mb-2"}
                    text={resource.Admin_Header_Home}
                    iconClass={"fas fa-home"}
                    onClick={() => history.push("/")}
                />
            </div>
        </div>
    );
};

const HeaderWithHistory = withRouter(AdminHeader);

export { HeaderWithHistory as AdminHeader };
